export var ColorPickerGridCellStyles = function (props) {
    return {};
};
//# sourceMappingURL=ColorPickerGridCell.styles.js.map